import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Legally-required (EU Directive 2023/2673) "withdrawal from contract" entry point.
// Pinned bottom-left (the right corner holds the scroll-to-top buttons) so it is visible without
// scrolling, and hidden while the footer is on screen so it never overlaps footer content.
// Styles live in css/style.scss (loaded site-wide).
const WithdrawalStickyButton = () => {
	const { t } = useTranslation();
	const [hidden, setHidden] = useState(false);

	useEffect(() => {
		let observer;
		let timeoutId;
		let cancelled = false;
		let attempts = 0;

		// The footer mounts at the bottom of the layout; wait for it before observing (capped at ~10s of polling).
		const attach = () => {
			if (cancelled) return;
			const footer = document.querySelector('footer');
			if (!footer) {
				if (attempts++ < 20) timeoutId = setTimeout(attach, 500);
				return;
			}
			observer = new IntersectionObserver(entries => setHidden(entries.some(entry => entry.isIntersecting)));
			observer.observe(footer);
		};
		attach();

		return () => {
			cancelled = true;
			if (timeoutId) clearTimeout(timeoutId);
			if (observer) observer.disconnect();
		};
	}, []);

	const label = t('withdrawal_page.sticky_button');

	return (
		<Link
			to="/right-of-withdrawal"
			className={`withdrawal-sticky-button${hidden ? ' is-hidden' : ''}`}
			aria-label={label}
			aria-hidden={hidden}
			tabIndex={hidden ? -1 : undefined}>
			<svg className="withdrawal-sticky-button__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="square"
					strokeLinejoin="miter"
					d="M6 3h8l4 4v14H6V3zM14 3v4h4M9 12h6M9 16h6"
				/>
			</svg>
			<span className="withdrawal-sticky-button__label">{label}</span>
		</Link>
	);
};

export default WithdrawalStickyButton;
